module.exports = __webpack_public_path__ + "static/img/adviserwechat.a518d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/adviserwechat.png
// module id = pMpH
// module chunks = 1